
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getStoreId, isBuyOnBehalf } from "../../Shared/AppContext/selectors";
import CloseIcon from "../../assets/images/close-icon.svg";

const ShippingInformation = ({
  whoPlaceOrder,
  setWhoPlaceOrder,
  primaryContactAddress,
  setPrimaryContactAddress,
  selectedAddress,
  setSelectedAddress,
  emails,
  setEmails,
  emailInputValue,
  setEmailInputValue,
  noAnyEmail,
  setNoAnyEmail,
  setErrorMsgPlaceOrder,
  bobEmailAddress, 
  setBobEmailAddress,
  includeDefaultConfirmationEmail,
  setIncludeDefaultConfirmationEmail,
  translationKey,
  currentFileRequired,
}) => {
  const storeId = useSelector(getStoreId);
  const [isEmptyEmail, setIsEmptyEmail] = useState(false);
  const [isInValidEmail, setIsInValidEmail] = useState(false);
  const [shipAddressList, setShipAddressList] = useState([]);

  const isBOB = useSelector(isBuyOnBehalf);

  const getShipToLocationSummary = (address) => {
    if (!address) {
      return "";
    }
    const city = address?.customerCity?.trim();
    const state = address?.customerState?.trim();
    const zip = address?.customerZipcode?.trim();
    const cityState = [city, state].filter(Boolean).join(", ");
    const cityStateZip = [cityState, zip].filter(Boolean).join(" ");
    if (cityStateZip) {
      return cityStateZip;
    }
    return (
      address?.customerAddress1?.trim() ||
      address?.customerAddress2?.trim() ||
      ""
    );
  };

  const getShipToOptionLabel = (address) => {
    const customerName = address?.customerName?.trim() || "";
    const locationSummary = getShipToLocationSummary(address);
    return locationSummary
      ? `${customerName} - ${locationSummary}`
      : customerName;
  };

  const handleAddressChange = (event) => {
    const selectedId = parseInt(event.target.value);
    const selected = shipAddressList[selectedId];
    setSelectedAddress(selected);
  };

  const addEmail = (e) => {
    e.preventDefault();
    const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;
    if (emailInputValue) {
      if (!emailRegex.test(emailInputValue)) {
        setIsInValidEmail(true);
      } else {
        setEmails([...emails, emailInputValue]);
        setEmailInputValue("");
        setNoAnyEmail(true);
        setErrorMsgPlaceOrder("");
      }
    } else {
      setIsEmptyEmail(true);
    }
  };

  const removeEmail = (emailIndex) => {
    const newEmails = [...emails];
    newEmails.splice(emailIndex, 1);
    setEmails(newEmails);
  };

  const handleEmailInput = (e) => {
    setIsEmptyEmail(false);
    setIsInValidEmail(false);
    setEmailInputValue(e.target.value);
  };

  const fetchShipAddressesData = async () => {
    try {
      const response = await fetch(
        `/wcs/resources/store/${storeId}/checkout/shipAddresses`,
        {
          method: "GET",
          credentials: "same-origin",
          cache: "no-cache",
        }
      );
      const data = await response.json();
      const isShipAddressList = data?.resultList.filter(
        (add) => add?.contactAddress === "N"
      );
      setShipAddressList(isShipAddressList);
      const isPrimaryContactAddres = data?.resultList.filter(
        (add) => add?.contactAddress === "Y"
      );
      setPrimaryContactAddress(isPrimaryContactAddres[0]);
      const isSelectedAddress = data?.resultList.filter(
        (add) => add?.defaultAddress === "Y"
      );
      setSelectedAddress(isSelectedAddress[0]);
      const bobEmailAddress = data?.bobEmailAddress;
      setBobEmailAddress(bobEmailAddress);
      if (isBOB && isPrimaryContactAddres[0]?.customerEmail) {
        setEmails((prevEmails) => {
          if (prevEmails.includes(isPrimaryContactAddres[0]?.customerEmail)) {
            return prevEmails;
          }
          return [...prevEmails, isPrimaryContactAddres[0]?.customerEmail];
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    fetchShipAddressesData();
  }, []);

  return (
    <>
      <div className="checkout-common-shadow-wrapper">
        <div className="checkout-sub-card-header">
          <h2 className="checkout-sub-header-title">
            1.{" "}
            {translationKey(
              currentFileRequired["SHIPPING_CONTACT_INFO_HEADER"]
            )}
          </h2>
        </div>
        <div className="enter-your-name-wrapper">
          <label>
            {translationKey(currentFileRequired["PLACING_ORDER_HEADER"])}
          </label>
          <input
            type="text"
            placeholder="Enter your name"
            value={whoPlaceOrder.wponame}
            onChange={(e) =>
              setWhoPlaceOrder({ ...whoPlaceOrder, wponame: e.target.value })
            }
          />
        </div>
        <div className="shipping-address-wrapper">
          <label>
            {translationKey(currentFileRequired["SHIPPING_ADDRESS"])}
          </label>
          <select
            defaultValue={selectedAddress?.customerName}
            onChange={handleAddressChange}
          >
            {shipAddressList.map((address, addressIndex) => (
              <option
                key={addressIndex.toString()}
                value={addressIndex}
                selected={
                  selectedAddress?.customerName == address?.customerName
                }
              >
                {getShipToOptionLabel(address)}
              </option>
            ))}
          </select>
          {selectedAddress && (
            <div className="selected-shipping-address">
              <p>{selectedAddress?.customerName}</p>
              <p>{selectedAddress?.customerAddress1}</p>
              <p>{selectedAddress?.customerAddress2}</p>
              <p>{selectedAddress?.customerAddress3}</p>
              <p>{selectedAddress?.customerAddress4}</p>
              <p>
                {selectedAddress?.customerCity},{" "}
                {selectedAddress?.customerState},{" "}
                {selectedAddress?.customerZipcode}
              </p>
            </div>
          )}
        </div>
        <div className="primary-address-wrapper">
          <label>
            {translationKey(currentFileRequired["PRIMARY_CONTACT_INFO_HEADER"])}
          </label>
          <div className="primary-address">
            <p>{primaryContactAddress?.customerName}</p>
            <p>{primaryContactAddress?.customerPhone}</p>
            <p>{primaryContactAddress?.customerEmail}</p>
          </div>
        </div>
        <div
          className={
            noAnyEmail
              ? "recipient-email-wrapper"
              : "recipient-email-wrapper noAnyEmail"
          }
        >
          <label>
            {translationKey(currentFileRequired["CONFIRMATION_HEADER"])}
          </label>
          <label className="recipient-email-title">
            {translationKey(currentFileRequired["RECIPIENT_EMAIL_HEADER"])}
          </label>
          <form onSubmit={addEmail} className="recipient-email-content">
            <input
              type="text"
              value={emailInputValue}
              placeholder={translationKey(currentFileRequired["ENTER_EMAIL"])}
              onChange={(e) => handleEmailInput(e)}
            />
            <button className="sec-btn">
              <span>+</span>{" "}
              {translationKey(currentFileRequired["ADD_RECIPIENT"])}
            </button>
          </form>
          {isEmptyEmail && (
            <div className="empty-input-error">
              {translationKey(
                currentFileRequired["ADD_RECIPIENT_EMAIL_MESSAGE"]
              )}
            </div>
          )}
          {isInValidEmail && (
            <div className="empty-input-error">
              {translationKey(
                currentFileRequired["VALID_EMAIL_ADDRESS_MESSAGE"]
              )}
            </div>
          )}
          <div className="email-list">
            {(isBOB ? includeDefaultConfirmationEmail : true) && (
              <span className={isBOB ? "new-email default-email" : "default-email"}>
                <span>
                  {isBOB ? bobEmailAddress : primaryContactAddress?.customerEmail}
                </span>
                {isBOB && (
                  <span
                    className="remove-icon"
                    onClick={() => setIncludeDefaultConfirmationEmail(false)}
                  >
                    <img alt="close" src={CloseIcon} />
                  </span>
                )}
              </span>
            )}
            {isBOB && !includeDefaultConfirmationEmail && bobEmailAddress && (
              <button
                type="button"
                className="restore-default-email"
                onClick={() => setIncludeDefaultConfirmationEmail(true)}
              >
                {translationKey(
                  currentFileRequired["RESTORE_DEFAULT_RECIPIENT"]
                )}
              </button>
            )}
            {emails.map((email, emailIndex) => (
              <span key={emailIndex.toString()} className="new-email">
                <span>{email}</span>
                <span
                  className="remove-icon"
                  onClick={() => removeEmail(emailIndex)}
                >
                  <img alt="close" src={CloseIcon} />
                </span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
export default ShippingInformation;
